import { render, staticRenderFns } from "./PageSMSContent.vue?vue&type=template&id=08520474&scoped=true&"
import script from "./PageSMSContent.vue?vue&type=script&lang=js&"
export * from "./PageSMSContent.vue?vue&type=script&lang=js&"
import style0 from "./PageSMSContent.vue?vue&type=style&index=0&id=08520474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08520474",
  null
  
)

export default component.exports